/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Group_Type_LabelInputs */

const en_new_project_group_type_label = /** @type {(inputs: New_Project_Group_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Group Type`)
};

const fr_new_project_group_type_label = /** @type {(inputs: New_Project_Group_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau type de groupe`)
};

const de_new_project_group_type_label = /** @type {(inputs: New_Project_Group_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer Gruppentyp`)
};

const it_new_project_group_type_label = /** @type {(inputs: New_Project_Group_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo tipo di gruppo`)
};

const ru_new_project_group_type_label = /** @type {(inputs: New_Project_Group_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новый тип группы`)
};

const es_new_project_group_type_label = /** @type {(inputs: New_Project_Group_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo tipo de grupo`)
};

const zh_cn2_new_project_group_type_label = /** @type {(inputs: New_Project_Group_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新组类型`)
};

const ja_new_project_group_type_label = /** @type {(inputs: New_Project_Group_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいグループタイプ`)
};

const hi_new_project_group_type_label = /** @type {(inputs: New_Project_Group_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया समूह प्रकार`)
};

const pt_pt2_new_project_group_type_label = /** @type {(inputs: New_Project_Group_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo tipo de grupo`)
};

/**
* | output |
* | --- |
* | "New Group Type" |
*
* @param {New_Project_Group_Type_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_group_type_label = /** @type {((inputs?: New_Project_Group_Type_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Group_Type_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_group_type_label(inputs)
	if (locale === "de") return de_new_project_group_type_label(inputs)
	if (locale === "it") return it_new_project_group_type_label(inputs)
	if (locale === "ru") return ru_new_project_group_type_label(inputs)
	if (locale === "es") return es_new_project_group_type_label(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_group_type_label(inputs)
	if (locale === "ja") return ja_new_project_group_type_label(inputs)
	if (locale === "hi") return hi_new_project_group_type_label(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_group_type_label(inputs)
	return en_new_project_group_type_label(inputs)
});